<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row">
          <i class="fa fa-list"></i>
          <span class="card-label fs-3 ms-1">Quản lý phản ánh</span>
        </h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tên:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Tên phản ánh..." clearable v-model="search.cTen" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Nhãn:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhãn..." clearable v-model="search.cNhan" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                  <el-option label="Tất cả" value="-1" selected></el-option>
                  <el-option label="Đã phản hồi" value="3" selected></el-option>
                  <el-option label="Chưa phản hồi" value="2" selected></el-option>
                  <el-option label="Chưa xác nhận" value="1" selected></el-option>
                  <el-option label="Đã xóa" value="0" selected></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Loại:</label>
            <div class="d-flex">
              <!-- <el-date-picker v-model="search.dateRange" type="daterange" start-placeholder="chọn ngày"
                                end-placeholder="chọn ngày" class="w-auto"></el-date-picker> -->
              <el-select placeholder="Tất cả" v-model="search.cLoai">
                <el-option label="Tất cả" value="" selected></el-option>
                <el-option label="Công khai" value="PUBLIC" selected></el-option>
                <el-option label="Cá nhân" value="PRIVATE" selected></el-option>
              </el-select>

              <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage" class="ms-2"><i
                  class="fa fa-search"></i></el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh"  style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="nMaPhanAnh" label="Mã" width="80" align="center"></el-table-column>
            <el-table-column prop="cTen" label="Phản ánh" min-width="150" header-align="center"></el-table-column>
            <el-table-column prop="cNhan" label="Nhãn" align="center" width="150">
            </el-table-column>
            <el-table-column prop="cLoai" label="Loại" width="100" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.cLoai == 'PUBLIC'" size="small">Công khai</el-tag>
                <el-tag type="warning" v-if="scope.row.cLoai == 'PRIVATE'" size="small">Cá nhân</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="" label="Trạng thái" width="100" align="center">
              <template #default="scope">
                <el-tag type="success"
                  v-if="scope.row.cLoai != null && scope.row.nTrangThai > 0 && scope.row.nTinhTrang != 0"
                  size="small">Đã
                  phản
                  hồi</el-tag>
                <el-tag type="primary"
                  v-if="scope.row.cLoai != null && scope.row.nTrangThai == 0 && scope.row.nTinhTrang != 0"
                  size="small">Chưa phản
                  hồi</el-tag>
                <el-tag type="warning" v-if="scope.row.cLoai == null && scope.row.nTinhTrang != 0" size="small">Chưa xác
                  nhận</el-tag>
                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="cNguoiTao" label="Người phản ánh" width="150" align="center"></el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" width="120" align="center">
              <template #default="scope">
                <span v-if="scope.row.dNgayTao">
                  {{ momentDate(scope.row.dNgayTao) }}
                </span>
              </template>
            </el-table-column>
            <!-- Button hành động -->
            <el-table-column width="200" align="center" label="Hành động">
              <template #default="scope">
                <!-- <el-button v-if="scope.row.cLoai == null" plain type="success" title="Xác nhận phản ánh"
                  :disabled="scope.row.nTinhTrang == 0" @click="handleOpenSaveReponse(scope.row)" data-bs-toggle="modal"
                  data-bs-target="#modal_response">
                  <span class="btn-inner--icon">
                    <i :class="'fa fa-check position-static'"></i>
                  </span>
                </el-button> -->

                <el-button v-if="scope.row.nTrangThai == 0" plain type="primary"
                  title="Phản hồi" :disabled="scope.row.nTinhTrang == 0" @click="handleOpenSaveReponse(scope.row)"
                  data-bs-toggle="modal" data-bs-target="#modal_response">
                  <span class="btn-inner--icon">
                    <i :class="'fas fa-reply position-static'"></i>
                  </span>
                </el-button>

                <el-button v-if="scope.row.nTrangThai > 0" plain type="primary"
                  title="Sửa phản hồi" :disabled="scope.row.nTinhTrang == 0" @click="handleOpenEditReponse(scope.row)"
                  data-bs-toggle="modal" data-bs-target="#modal_response">
                  <span class="btn-inner--icon">
                    <i :class="'fas fa-edit position-static'"></i>
                  </span>
                </el-button>

                <el-button plain type="danger" :disabled="scope.row.nTinhTrang == 0"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_response" ref="modalRef" tabindex="1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-550px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_response_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">
              {{ selected.cLoai == null ? 'Xác nhận loại phản ánh' : operation ? 'Sửa phản hồi' : 'Thêm phản hồi' }}
            </h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body">
            <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="100" class=" d-flex flex-column">
              <el-form-item class="mb-5" label="Tên phản hồi" prop="cTenPhanHoi">
                <el-input placeholder="Tên..." class="overflow-hidden rounded" v-model="formData.cTenPhanHoi">
                </el-input>
              </el-form-item>
              <el-form-item class="mb-5" label="Nội dung" prop="cNoiDung">
                <el-input placeholder="Nội dung..." class="overflow-hidden rounded" v-model="formData.cNoiDung"
                  type="textarea" :rows="4">
                </el-input>
              </el-form-item>
              <el-form-item class="mb-5" label="Loại" prop="cLoai">
                <el-radio-group v-model="formData.cLoai">
                  <el-radio value="PUBLIC" >Công khai</el-radio>
                  <el-radio value="PRIVATE" >Cá nhân</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="Hình ảnh" prop="imageFile">
                <el-upload action="#" list-type="picture-card" :auto-upload="false" placeholder="Chọn hình ảnh"
                  :on-preview="handlePictureCardPreview" ref="upload" :file-list="imageFile"
                  :on-change="handleChangeFile" :on-remove="handleRemoveFile" accept="image/*">
                  <div class="d-flex align-items-center justify-content-center w-100 h-100">
                    <i class="el-icon-plus" v-if="imageFile.length == 0"></i>
                    <i class="el-icon-refresh" v-if="imageFile.length > 0"></i>
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
            <!-- <div class="d-flex align-items-center justify-content-center" v-else>
              <el-button @click="handleSelectType('PUBLIC')" type="success" plain>Công
                khai</el-button>
              <el-button @click="handleSelectType('PRIVATE')" type="primary" plain>Cá
                nhân</el-button>
            </div> -->
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <!-- <el-button @click="handleSelectType('PUBLIC')" type="success" plain v-if="selected.cLoai == 'PRIVATE'">Công
                khai</el-button>
              <el-button @click="handleSelectType('PRIVATE')" type="primary" plain v-if="selected.cLoai == 'PUBLIC'">Cá
                nhân</el-button> -->
              <el-button title="Thêm phản hồi" plain type="success" class="feedbackResponse" @click="handleSaveResponse"
                v-if="selected.cLoai != null">Lưu</el-button>
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>
<script>
import { Feedbacks } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal, showModal } from "@/core/helpers/dom";
import { ElMessage } from "element-plus";
import { baseUrl } from "@/utils/global";
export default {
  name: 'feedback',
  data() {
    return {
      search: {
        cTen: "",
        cLoai: "",
        cNhan: "",
        nTinhTrang: "-1",
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        cTenPhanHoi: "",
        cNoiDung: "",
        imageFile: [],
        cLoai:""
      },
      rules: {
        cTenPhanHoi: [{ required: true, message: "Xin vui lòng nhập tên phản hồi", trigger: "blur" }],
        cNoiDung: [{ required: true, message: "Xin vui lòng nhập nội dung", trigger: "blur" }]
      },
      tableData: {
        content: [{}]
      },
      isLoading: false,
      modalVisible: false,
      openIframe: false,
      isSearchLoading: false,
      size: "small",
      operation: false,
      response: [],
      store: useStore(),
      originalResponse: "",
      selected: {},
      imageFile: [],
      feedbackTypes: [],
      baseUrl: baseUrl,
      dialogVisible: false,
      dialogImageUrl: ""
    }
  },
  watch: {
    modalVisible() {
      if (!this.modalVisible) {
        this.imageFile = []
      }
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleClose() {
      this.modalVisible = false
      if (this.selected.cLoai != null) {
        this.$refs.formDataRef.resetFields()
      }

      hideModal(this.$refs.modalRef)
    },
    handleSelectType(val) {
      /* this.$confirm("Bạn có chắc muốn chọn loại " + (val == "PRIVATE" ? "cá nhân" : "công khai") + "?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      }).then(() => { */
        this.store.dispatch(Feedbacks.updateFeedbackById, { ...this.selected, cLoai: val, nTrangThai: 1 }).then(res => {
          if (res.code == 200) {
            this.handleFindPage()
            this.handleClose()
            ElMessage({ message: "Xác nhận loại phản ánh thành công", type: "success" });
          } else {
            ElMessage({ message: "Xác nhận loại phản ánh không thành công", type: "error" });
          }
        }).catch(() => {
          ElMessage({ message: "Xác nhận loại phản ánh không thành công", type: "error" });
        })
      /* }).catch(() => {

      }) */

    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa phản ánh này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Feedbacks.deleteFeedbackById, val.nMaPhanAnh).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa phản ánh thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa phản ánh thất bại", type: "error" });
          })
        })
    },
    async handleChangeFile(file, imageFile) {
      this.imageFile = [file]
      this.formData.imageFile = this.imageFile
    },
    handleRemoveFile(file, imageFile) {
      this.formData.imageFile = []
      this.formData.imageFile = this.imageFile
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cTen: { value: this.search.cTen },
        cLoai: { value: this.search.cLoai },
        cNhan: { value: this.search.cNhan },
        nTinhTrang: { value: this.search.nTinhTrang },
      }
      this.store.dispatch(Feedbacks.getAllFeedbackByFilter, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm kiếm thất bại", type: "error" });
      })
    },
    handleOpenSaveReponse(val) {
      this.formData.nMaPhanAnh = val.nMaPhanAnh
      this.formData.cLoai = val.cLoai
      this.modalVisible = true
      this.operation = false
      this.selected = Object.assign({}, val)

      hideModal(this.$refs.feedbackModalRef)
    },
    handleOpenEditReponse(val) {
      this.selected = Object.assign({}, val)
      this.modalVisible = true
      this.operation = true
      this.handleFindFeedBackResponse(val)
    },
    handleSaveResponse() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid) {
          const formData = new FormData();
          const data = {
            nMaPhanAnh: this.selected.nMaPhanAnh,
            cTenPhanHoi: this.formData.cTenPhanHoi,
            cNoiDung: this.formData.cNoiDung,
            nTrangThai: 1,
          }
          if (this.imageFile.length > 0) {
            if (this.imageFile[0].status == "ready") {
              formData.append('image', this.imageFile[0].raw)
            }
          }
          if (this.operation) {
            this.$refs.formDataRef.validate((valid) => {
              if (valid) {
                data.nMaPhanHoi = this.formData.nMaPhanHoi
                formData.append('responseRequest', new Blob([JSON.stringify(data)], { type: "application/json" }))
                this.store.dispatch(Feedbacks.updateResponseByFeedbackId, { nMaPhanAnh: data.nMaPhanAnh, nMaPhanHoi: data.nMaPhanHoi, formData: formData }).then(res => {
                  if (res.code == 200) {
                    this.handleSelectType(this.formData.cLoai)
                    /* this.handleFindPage() */
                    this.$refs.formDataRef.resetFields()
                    ElMessage({ message: "Cập nhật phản hồi thành công", type: "success" })
                    this.handleClose()

                  } else {
                    ElMessage({ message: "Cập nhật phản hồi không thành công", type: "error" })
                  }
                }).catch(() => {
                  ElMessage({ message: "Cập nhật phản hồi không thành công", type: "error" })
                })
              }
            })
          }
          else {
            formData.append('responseRequest', new Blob([JSON.stringify(data)], { type: "application/json" }))
            this.store.dispatch(Feedbacks.insertResponsesByFeedbackId, { nMaPhanAnh: data.nMaPhanAnh, formData: formData }).then(res => {
              if (res.code == 200) {
                this.handleSelectType(this.formData.cLoai)
                /* this.handleFindPage() */
                this.$refs.formDataRef.resetFields()
                ElMessage({ message: "Lưu phản hồi thành công", type: "success" })
                this.handleClose()
              } else {
                ElMessage({ message: "Lưu phản hồi không thành công", type: "error" })
              }
            }).catch(() => {
              ElMessage({ message: "Lưu phản hồi không thành công", type: "error" })
            })
          }

        }
      })
    },
    addImageFromURL(url) {
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], "image.jpg", { type: blob.type });
          this.imageFile.push({
            name: file.name,
            url: URL.createObjectURL(file),
            status: 'success',
            uid: Date.now(),
            raw: file
          });
        });
    },
    handlePictureCardPreview(val) {
      this.dialogImageUrl = val.url
      this.dialogVisible = true
    },
    handleFindFeedBackResponse(val) {
      this.store.dispatch(Feedbacks.getAllResponseByFeedbackId, { feedbackId: val.nMaPhanAnh }).then(res => {
        if (res.code == 200) {
          this.formData = Object.assign({}, res.data.content[0])
          this.formData.cLoai = val.cLoai
          if (this.formData.cHinhAnh) {
            this.addImageFromURL(baseUrl + this.formData.cHinhAnh)
          }
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm kiếm phản hồi thất bại", type: "error" });
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss" scoped>
.overflow-y-auto {
  overflow-y: auto !important;
}
</style>
<style lang="scss">
.item-daterange-control {
  color: #000;
  border: 1px solid #b1b4b8;
  height: 1.6rem !important;

  .el-input__icon {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>